<app-navbar-style-three></app-navbar-style-three>
<section class="news-events-section">
  <div class="container">
    <!-- Header -->
    <div class="section-header">
      <h1 class="section-title">News and Events</h1>
    </div>

    <!-- News Items -->
    <ng-container *ngIf="News_event_data != null">
      <article 
        class="news-card"
        *ngFor="let item of News_event_data; let i = index"
        [class.news-card--reverse]="i % 2 !== 0"
      >
        <div class="news-card__image-wrapper">
          <img 
            [src]="item.ShowAttachments[0].FilePath" 
            [alt]="item.TitleEn"
            class="news-card__image"
            loading="lazy"
          />
        </div>
        
        <div class="news-card__content">
          <h2 class="news-card__title">{{ item.TitleEn }}</h2>
          <div class="news-card__excerpt" [innerHTML]="item.DetailsEn"></div>
          <a 
            [routerLink]="['/news-and-events', item.Id]" 
            class="news-card__link"
          >
            Read more
            <svg class="news-card__link-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </article>
    </ng-container>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="News_event_data == null || News_event_data.length === 0">
      <p class="empty-state__text">No news or events available at the moment.</p>
    </div>
  </div>
</section>
